import React, { useContext, useState } from 'react'
import MyAccountRecentOrdersAndDeliveryPassUI from '@interflora/ui-components/build/components/MyAccountRecentOrdersAndDeliveryPass/MyAccountRecentOrdersAndDeliveryPass'
import { Order } from '@interflora/ui-components/build/common/props'
import { useMutation, useQuery } from '@apollo/client'
import { ADD_DELIVERY_PASS_TO_CART, GET_HISTORIC_ORDERS } from 'graphql/queries'
import { useOnceCall } from 'utils/common'
import { useRouter } from 'next/router'
import AnalyticsContext from 'context/AnalyticsContext'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import { useLoaded } from '@interflora/ui-components'

const MyAccountRecentOrdersAndDeliveryPass = (props: object) => {
  const { getCustomer } = useContext(SiteContext)
  const customerId = getCustomer?.data?.customer?.id
  const router = useRouter()
  const [order, setOrder] = useState<Order>()
  const analytics = useContext(AnalyticsContext)

  const { refetch } = useQuery(GET_HISTORIC_ORDERS, {
    variables: { input: { page: 1, pageSize: 1 } },
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setOrder(data.historicOrders.orders[0])
    },
    ssr: false,
    skip: !customerId,
  })

  useOnceCall(refetch)

  /** add to cart mutation */
  const [addToBasketMutation] = useMutation(ADD_DELIVERY_PASS_TO_CART)

  const addToBasket = async (sku: string) => {
    const response = await addToBasketMutation({ variables: { input: { sku } } })
    const items = response.data.addDeliveryPassToCart?.consignments

    const idpType = sku == 'INTERFLORAPLATINUM' ? 'Platinum' : 'Gold'
    analytics.idpJourney('My Account', idpType)
    if (items?.length === 1) {
      /** redirecting to checkout contact information page */
      router.push('/checkout/contact')
    } else if (items?.length > 1) {
      /** redirecting to basket page if the basket is not empty */
      router.push('/basket')
    } else {
      throw new Error('No consignments found')
    }
  }

  useLoaded(props)

  return <MyAccountRecentOrdersAndDeliveryPassUI order={order} addToBasket={addToBasket} />
}

export default MyAccountRecentOrdersAndDeliveryPass
